import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { IEnumApi } from "../enum-api";

export const ContractInsurance = types
  .compose(
    Base,
    types.model({
      contractType: types.maybeNull(types.number),
      contractNumber: types.maybeNull(types.string),
      contractSigningDate: types.maybeNull(types.string),
      contractExpirationDate: types.maybeNull(types.string),
      contractNote: types.maybeNull(types.string),
      socialInsuranceNumber: types.maybeNull(types.string),
      healthInsuranceNumber: types.maybeNull(types.string),
      insurancePaymentDate: types.maybeNull(types.string),
      insuranceNote: types.maybeNull(types.string),
      cdJoiningDate: types.maybeNull(types.string),
      personalTaxID: types.maybeNull(types.string),
      kcbPlace: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      contractTermType: types.maybeNull(types.number),
      contractTypeModel: types.maybeNull(types.frozen<IEnumApi>()),
      contractTermTypeModel: types.maybeNull(types.frozen<IEnumApi>()),
    })
  )
  .actions(withSetPropAction);
export interface IContractInsurance
  extends Instance<typeof ContractInsurance> {}
export interface IContractInsuranceProperties
  extends SnapshotIn<typeof ContractInsurance> {}

export interface IUpdateContractInsurance
  extends Pick<
    IContractInsuranceProperties,
    | "contractType"
    | "contractTermType"
    | "contractNumber"
    | "contractSigningDate"
    | "contractExpirationDate"
    | "contractNote"
    | "socialInsuranceNumber"
    | "healthInsuranceNumber"
    | "insurancePaymentDate"
    | "insuranceNote"
    | "cdJoiningDate"
    | "personalTaxID"
    | "kcbPlace"
    | "note"
  > {}
